import { Controller } from "@hotwired/stimulus";

// Coordinates row autosubmits (verdict taps, count/comment changes)
// against the page's own Submit button. A row save and Submit can race on
// a phone: without this, Submit could beat a still-in-flight row PATCH to
// the server and submit a stale count (Gate 2). While any row save is
// pending, flushBeforeSubmit swallows the Submit click and remembers the
// attempt; when the last pending save settles, the button re-enables and
// a swallowed attempt replays.
export default class extends Controller {
  static targets = ["submit"];

  connect() {
    this.pending = 0;
    this.swallowedSubmit = false;
    this.abortController = new AbortController();
    const { signal } = this.abortController;
    this.element.addEventListener("turbo:submit-start", this.onSubmitStart, { signal });
    this.element.addEventListener("turbo:submit-end", this.onSubmitEnd, { signal });
  }

  disconnect() {
    this.abortController.abort();
  }

  flushBeforeSubmit(event) {
    if (this.pending === 0) return;
    event.preventDefault();
    this.swallowedSubmit = true;
    if (this.hasSubmitTarget) this.submitTarget.disabled = true;
  }

  // Batch-review fix (spec IMP-1): disabling here made flushBeforeSubmit
  // unreachable — a phone tap straight after a row save starts (count blur
  // -> change -> row PATCH -> this fires -> button already disabled) never
  // produces a click/submit event, so the tap was silently dropped instead
  // of deferred. flushBeforeSubmit is the only place that disables.
  onSubmitStart = (event) => {
    if (this.isSubmissionForm(event.target)) return;
    this.pending += 1;
  };

  onSubmitEnd = (event) => {
    if (this.isSubmissionForm(event.target)) return;
    this.pending = Math.max(0, this.pending - 1);
    if (this.pending > 0) return;
    if (this.hasSubmitTarget) this.submitTarget.disabled = false;
    if (this.swallowedSubmit) {
      this.swallowedSubmit = false;
      this.submitTarget?.form?.requestSubmit();
    }
  };

  isSubmissionForm(target) {
    return this.hasSubmitTarget && target === this.submitTarget.form;
  }
}
